import React from 'react';
import { TextField, useTheme, useMediaQuery } from '@mui/material';

const BaseTextField = ({
  sx = {},
  InputProps = {},
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <TextField
      {...props}
      InputProps={{
        ...InputProps
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          backgroundColor: '#f8faff',
          '& input': {
            caretColor: '#3F51B5'
          },
          '& fieldset': {
            borderColor: '#e1e8f0',
            borderWidth: 2
          },
          '&:hover fieldset': {
            borderColor: '#3F51B5'
          },
          '&.Mui-focused fieldset': {
            borderColor: '#3F51B5',
            borderWidth: 2
          },
          '&.Mui-error fieldset': {
            borderColor: '#f44336',
            borderWidth: 2
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0,0,0,0.04)',
            '& fieldset': {
              borderColor: 'rgba(0,0,0,0.12)'
            }
          }
        },
        '& .MuiInputBase-input': {
          fontSize: '16px' // Toujours 16px pour éviter le zoom automatique sur iOS
        },
        '& .MuiInputBase-input::placeholder': {
          fontSize: '16px',
          opacity: 0.7
        },
        '& .MuiInputLabel-root': {
          fontWeight: 600,
          color: '#2c3e50',
          fontSize: '16px', // Toujours 16px pour cohérence
          '&.Mui-error': {
            color: '#f44336'
          }
        },
        '& .MuiFormHelperText-root': {
          fontSize: '14px', // 14px acceptable pour helper text (pas interactif)
          marginLeft: '4px',
          marginTop: '8px'
        },
        // Pour les textarea
        '& .MuiInputBase-multiline': {
          '& textarea': {
            fontSize: '16px' // Toujours 16px pour éviter le zoom
          }
        },
        ...sx
      }}
    />
  );
};

export default BaseTextField; 